// Angular
import { Component, Input, OnDestroy, OnInit } from '@angular/core';

// Services
import { LayoutConfigService } from '../../services/layout-config.service';

// Libraries
import * as objectPath from 'object-path';
import { takeUntil } from 'rxjs';

// Models
import { AppCleanup } from '../../models';

// Helpers
import { UtilityHelper } from '../../helpers';

@Component({
    selector: 'app-spinner',
    templateUrl: './spinner.component.html',
    styleUrls: ['./spinner.component.scss'],
})
export class AppSpinnerComponent extends AppCleanup implements OnInit, OnDestroy {
    @Input() size: SpinnerSizeType | string = SpinnerSizeType.MEDIUM;
    primaryColor: string;

    constructor(private layoutConfigService: LayoutConfigService) {
        super();
    }

    ngOnInit() {
        this.layoutConfigService.localLayoutConfig$.pipe(takeUntil(this.destroy)).subscribe((layoutConfig) => {
            if (layoutConfig) {
                this.primaryColor = objectPath.get(layoutConfig, 'loader.color');
                this.setColor();
            }
        });
    }

    setColor() {
        let id = 'spinner-style';
        let style = `
            .mdc-circular-progress__indeterminate-circle-graphic {
                stroke: ${this.primaryColor} !important;
            }
        `;
        UtilityHelper.insertStyleTagDom(id, style);
    }
}

export enum SpinnerSizeType {
    LARGE = 'lg',
    MEDIUM = 'md',
    SMALL = 'sm',
    EXTRA_SMALL = 'xs',
}
